<template>
  <div class="aside-menu">
    <div class="logo clearfix">
      <div class="fl">
        <img src="../assets/logo_ld.png"
             alt="">
      </div>
      <div class="fl">
        <div class="logoTitle">魔镜·镜界AI</div>
        <div class="logoText">mktindex</div>
      </div>
      <el-popover placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="popoverContent">
        <div :class="['relieve', { nosticky: !leftSideSticky }]"
             slot="reference"
             @click="handleStickyClick">
          <i class="iconfont icon-relieve"></i>
        </div>
      </el-popover>

    </div>
    <div class="start-chat-content">
      <div class="start-chat-btn"
           @click="newChat">
        <i class="iconfont icon-chat"
           style="margin-right: 5px"></i>开始新对话
      </div>
    </div>
    <el-menu :default-openeds="defaultOpeneds"
             :default-active="defaultActive"
             @select="handelSelect"
             class="bot-el-menu"
             @open="expandDefault = true"
             @close="expandDefault = false"
             v-if="showMenu">
      <el-submenu index="default">
        <template slot="title">
          <div class="sub-menu-title">
            <i v-if="!expandDefault"
               class="iconfont icon-yousanjiao"
               style="color: black;margin-right: 5px;"></i>
            <i v-if="expandDefault"
               class="iconfont icon-xiasanjiao"
               style="color: black;margin-right: 5px;"></i>
            <span>回答样例</span>
          </div>
        </template>
        <template v-for="item in asideData">
          <el-menu-item :index="item.conv_id"
                        :key="item.conv_id">
            <div class="menu-item ready">
              <div class="icon-div">
                <i class="menu-icon ready"></i>
              </div>
              <div class="span-div">
                {{item.title}}
              </div>
            </div>
          </el-menu-item>
        </template>
      </el-submenu>
      <div class="month-area"
           v-for="ele in groupData"
           :key="ele.month">
        <div class="month-title">{{ele.month}}</div>
        <el-menu-item :index="item.index"
                      v-for="(item) in ele.data"
                      @click="routeTo(item.routeName)"
                      :key="item.index">
          <div class="menu-item"
               @mouseover="item.showDelete = true"
               @mouseleave="item.showDelete = false"
               :class="item.status">
            <div class="item-area">
              <div class="icon-div">
                <i :class="item.status"
                   class="menu-icon"></i>
              </div>
              <div class="span-div">
                <span slot="title"
                      v-if="item.status == 'ready' || !item.status"
                      :title='item.label'
                      style="margin-right: 10px;">
                  {{item.label}}
                </span>
                <span slot="title"
                      v-else-if="item.status == 'answering'"
                      :title='item.label'
                      style="margin-right: 10px; ">
                  回答中...
                </span>
                <span slot="title"
                      v-else-if="item.status == 'waiting'"
                      :title='item.label'
                      style="margin-right: 10px;">
                  等待用户反馈…
                </span>
                <span slot="title"
                      v-else-if="item.status == 'timeout'"
                      :title='item.label'
                      style="margin-right: 10px;">
                  回答超时
                </span>
                <el-tooltip class="item"
                            v-show="item.showDelete"
                            :content="content"
                            placement="bottom">
                  <i class="iconfont icon-xiazai"
                     style="margin-right: 10px; color: #1d2043"
                     @click.stop="download(item)"></i>
                </el-tooltip>
                <i class="iconfont icon-lajitong"
                   v-show="item.showDelete"
                   @click.stop="deleteItem(item)"
                   style="color: #1d2043"></i>
                <div class="aside-loader"
                     v-if="item.downloading"
                     style=""></div>
              </div>
            </div>

          </div>
        </el-menu-item>
      </div>
      <!-- <div class="month-area">
        <div class="month-title">2025-05</div>
        <el-menu-item :index="item.index"
                      v-for="(item,index) in menueData"
                      @click="routeTo(item.routeName)"
                      :key="item.index">
          <div class="menu-item"
               :class="item.status">
            <div class="item-area">
              <div class="icon-div">
                <i :class="item.status"
                   class="menu-icon"></i>
              </div>
              <div class="span-div"
                   @mouseover="item.showDelete = true"
                   @mouseleave="item.showDelete = false">
                <span slot="title"
                      v-if="item.status == 'ready' || !item.status"
                      :title='item.label'
                      style="margin-right: 10px;">
                  {{item.label}}
                </span>
                <span slot="title"
                      v-else-if="item.status == 'answering'"
                      :title='item.label'
                      style="margin-right: 10px; ">
                  回答中...
                </span>
                <span slot="title"
                      v-else-if="item.status == 'waiting'"
                      :title='item.label'
                      style="margin-right: 10px;">
                  等待反馈...
                </span>
                <span slot="title"
                      v-else-if="item.status == 'timeout'"
                      :title='item.label'
                      style="margin-right: 10px;">
                  回答超时
                </span>
                <el-tooltip class="item"
                            v-show="item.showDelete"
                            :content="content"
                            placement="bottom">
                  <i class="iconfont icon-xiazai"
                     style="margin-right: 10px; color: #1d2043"
                     @click.stop="download(item)"></i>
                </el-tooltip>
                <i class="iconfont icon-lajitong"
                   v-show="item.showDelete"
                   @click.stop="deleteItem(index)"
                   style="color: #1d2043"></i>
                <div class="aside-loader"
                     v-if="item.downloading"
                     style=""></div>
              </div>
            </div>

          </div>
        </el-menu-item>
      </div> -->

      <!-- <el-menu-item :index="'7366539a7b8a4aad8e37a4755454ac89'">
        <div class="menu-item">
          <div class="item-area">
            <div class="span-div">
              <span slot="title"
                    :title='"test"'
                    style="margin-right: 10px;">
                test
              </span>
            </div>
          </div>
        </div>
      </el-menu-item> -->
      <el-dialog :visible.sync="showDialog"
                 append-to-body
                 width="40%">
        <span>确定删除对话【{{currentDeleteIndex ? currentDeleteIndex.label : ''}}】吗?</span>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="showDialog = false">取 消</el-button>
          <el-button type="primary"
                     @click="deleteChat">确 定</el-button>
        </span>
      </el-dialog>
    </el-menu>
    <div class="setup-btn-area "
         :class="{'is-active': isSet}"
         ref="setup">
      <!-- <div class="setup-btn"
           @click="jumpToInvite">
        <i class="el-icon-present"
           style="font-size: 16px;padding: 0 20px"></i>
        <span>邀请码</span>
      </div> -->
      <el-popover placement="top"
                  trigger="hover">
        <div>
          <img style="width: 200px"
               src="../assets/kf.png"
               alt=""
               v-if="!kfImg">
          <img style="width: 200px"
               :src="kfImg"
               alt=""
               v-if="kfImg">
        </div>
        <div style="text-align:center;display: inline-block;width: 190px"
             :class="{'en-font': $i18n.locale == 'en'}">扫码即刻获取专业帮助</div>
        <div class="setup-btn"
             slot="reference">
          <i class="iconfont icon-chat"
             style="font-size: 16px;padding: 0 20px"></i>
          <span>联系客服</span>
        </div>
      </el-popover>

      <div class="setup-btn"
           @click="routeToSet('setup')">
        <i class="el-icon-setting"
           style="font-size: 16px;padding: 0 20px"></i>
        <span>个人中心</span>
      </div>

    </div>
  </div>
</template>

<script>
import {
  postNewChat,
  postUserHistory,
  postDeleteConv,
  postAskChat,
  getAgentQrCode,
} from '@/api/public'

import { getObjFromUrl, jumpToBlank, isProductionEnvironment } from '@/utils'
import { downloadFileByLink } from '@/utils/download.js'
import { DateTime } from 'luxon'
export default {
  name: 'AsideMenue',
  components: {},
  data() {
    let leftSideSticky = localStorage.getItem('leftSideSticky')
    if (leftSideSticky) {
      switch (leftSideSticky) {
        case 'true':
          leftSideSticky = true
          break
        case 'false':
          leftSideSticky = false
          break
        default:
          leftSideSticky = false
      }
    } else {
      leftSideSticky = false
    }
    return {
      defaultOpeneds: [''], //['1', '3']
      defaultActive: '',
      menueData: [],
      currentDeleteIndex: null,
      showDialog: false,
      content: '下载成文档',
      downloadItem: {},
      showMenu: true,
      isSet: false,
      jumpToBlank,
      expandDefault: false,
      kfImg: '',
      leftSideSticky: leftSideSticky,
      groupData: [],
    }
  },
  created() {
    this.deboundDownloading = _.debounce(this.downloadMethod, 1000)
    let url = ''
    const currentDomain = window.location.hostname
    if (isProductionEnvironment()) {
      url = 'https://radar.mktindex.com/api/agent_qr_code'
    } else {
      url = 'https://radartest.mktindex.com/api/agent_qr_code'
    }
    getAgentQrCode(url).then((res) => {
      if (res.status == 'ok') {
        const result = res.result
        this.kfImg = result
        this.$store.dispatch('user/changeKfImgUrl', result)
      }
    })
  },
  methods: {
    jumpToInvite() {
      this.handelSelect('invite')
      this.defaultActive = ''
    },
    handleStickyClick() {
      const leftSideSticky = localStorage.getItem('leftSideSticky')
      if (!leftSideSticky || leftSideSticky == 'false') {
        localStorage.setItem('leftSideSticky', true)
        this.leftSideSticky = true
      } else {
        localStorage.setItem('leftSideSticky', false)
        this.leftSideSticky = false
      }
    },
    getHistoryMenuData() {
      return postUserHistory().then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          this.groupData = []
          this.groupData = this.groupByMonth(result.data)

          this.menueData = result.data.map((item, index) => {
            const temp = {
              index: item.conv_id,
              label: item.title,
              icon: 'iconfont icon-chat',
              showDelete: false,
              status: item.status,
            }
            return temp
          })
        }
      })
    },
    groupByMonth(data) {
      let cloneData = _.cloneDeep(data)
      // 创建一个Map来存储按月分组的数据
      const monthGroups = new Map()

      cloneData.forEach((item) => {
        // 使用Luxon解析日期
        const dt = DateTime.fromFormat(item.date, 'yyyy-MM-dd HH:mm:ss')
        // 生成月份key (格式: YYYY-MM)
        const monthKey = dt.toFormat('yyyy-MM')

        // 如果该月份组不存在，则创建一个新数组
        if (!monthGroups.has(monthKey)) {
          monthGroups.set(monthKey, [])
        }

        // 将当前项添加到对应月份组
        const temp = {
          index: item.conv_id,
          label: item.title,
          icon: 'iconfont icon-chat',
          showDelete: false,
          status: item.status,
        }
        item = {
          ...item,
          ...temp,
        }
        monthGroups.get(monthKey).push(item)
      })

      // 将Map转换为所需的数组格式，并按月份降序排序
      const result = Array.from(monthGroups, ([month, cloneData]) => ({
        month,
        data: cloneData,
      })).sort((a, b) => b.month.localeCompare(a.month))
      return result
    },
    getStatusStyle(item) {
      const status = item.status
      if (status) {
        if (status == 'answering') {
          return { color: '#4CAF50' }
        } else if (status == 'waiting') {
          return { color: '#eec55b' }
        } else if (status == 'timeout') {
          return { color: ' #F44336' }
        } else if (status == 'ready') {
          return {}
        }
      }
    },
    routeToSet() {
      this.handelSelect('setup')
      this.defaultActive = ''
    },
    changeTitle(title, id) {
      const menueItem = this.menueData.find((item) => {
        return item.index == id
      })
      menueItem.label = title
    },
    deleteChat() {
      const item = this.currentDeleteIndex
      postDeleteConv({
        conv_id: item.index,
      })
        .then((res) => {
          if (res.result.status == 'success') {
            this.$message.success('删除成功')
            this.getHistoryMenuData().then(() => {
              if (
                this.menueData.length > 0 &&
                this.$store.state.user.chatId == item.index
              ) {
                this.defaultActive = this.menueData[0].index
                this.$store.dispatch(
                  'user/changeChatId',
                  this.menueData[0].index
                )
              }
              if (this.menueData.length == 0) {
                this.newChat()
              }
            })
          }
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    deleteItem(item) {
      this.currentDeleteIndex = item
      this.showDialog = true
    },
    routeTo(routeName) {
      this.$router.push({
        name: routeName,
      })
    },
    containsDefault(str) {
      return /default/i.test(str)
    },
    handelSelect(convId) {
      if (!this.loginInfo && !this.containsDefault(convId)) {
        this.$eventBus.$emit('showLoginDialog')
        return
      }
      this.$emit('on-clearHomeInput')
      if (convId == 'setup') {
        this.isSet = true
      } else {
        this.isSet = false
      }
      if (this.containsDefault(convId)) {
        this.$store.dispatch('user/changeChatId', convId)
      } else {
        this.getHistoryMenuData().then(() => {
          const item = this.menueData.find((item) => item.index == convId)
          const status = item ? item.status : ''
          const chatStatus = {
            chatId: convId,
            status,
          }
          this.$store.dispatch('user/changeChatStatus', chatStatus).then(() => {
            this.$store.dispatch('user/changeChatId', convId)
          })
        })
      }
    },
    newChat() {
      if (!this.loginInfo) {
        this.$eventBus.$emit('showLoginDialog')
        return
      }
      this.$emit('on-clearHomeInput')
      postNewChat().then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          this.menueData.push({
            index: result.conv_id,
            label: '新对话',
            icon: 'iconfont icon-chat',
            showDelete: false,
          })
          this.getHistoryMenuData().then(() => {
            this.defaultActive = result.conv_id
            this.$store.dispatch('user/changeChatId', result.conv_id)
          })
          if (this.menueData.length == 1) {
            this.showMenu = false
            this.$nextTick(() => {
              this.showMenu = true
            })
          }
        }
      })
    },
    download(item) {
      this.downloadItem = item
      this.deboundDownloading()
    },
    downloadMethod() {
      const item = this.downloadItem
      item.downloading = true
      this.$forceUpdate()
      const id = item.index
      this.downloading = true
      postAskChat({
        conv_id: id,
        type: 'download',
        content: '',
      })
        .then((res) => {
          const link = res.result.url
          this.content = '下载成文档'
          if (link) {
            downloadFileByLink(link).then(() => {
              item.downloading = false
              this.$forceUpdate()
            })
          } else {
            this.$message.error('生成文档失败')
          }
        })
        .catch((error) => {
          if (error.backMsg) {
            this.$message.error(error.backMsg)
          } else {
            this.$message.error('生成文档失败')
          }
          item.downloading = false
          this.$forceUpdate()
          this.content = '下载成文档'
        })
    },
    changeChat(result) {
      this.menueData.push({
        index: result.conv_id,
        label: '新对话',
        icon: 'iconfont icon-chat',
        showDelete: false,
      })
      this.defaultActive = result.conv_id
      this.$store.dispatch('user/changeChatId', result.conv_id)
      if (this.menueData.length == 1) {
        this.showMenu = false
        this.$nextTick(() => {
          this.showMenu = true
        })
      }
    },
  },
  mounted() {
    this.$eventBus.$on('changeTitle', this.changeTitle)
    this.$eventBus.$on('homeNewChat', this.changeChat)
    this.$eventBus.$on('userInputQuestion', this.getHistoryMenuData)
  },
  computed: {
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
    asideData() {
      return this.$store.state.user.asideData
    },
    popoverContent() {
      return this.leftSideSticky ? '解除左侧边栏固定' : '定住左侧边栏'
    },
  },
  watch: {
    '$store.state.user.chatStatus': {
      handler(newVal) {
        const { chatId, status } = newVal
        const item = this.menueData.find((ele) => {
          return ele.index == chatId
        })
        if (item && item.status != status) {
          this.getHistoryMenuData()
        }
      },
    },
    menueData: {
      handler(newVal) {
        this.$store.dispatch('user/changeMenuData', newVal)
      },
      deep: true,
    },
    loginInfo: {
      handler(newVal) {
        if (newVal && newVal.username) {
          this.expandDefault = false
          this.defaultOpeneds = ['']
          const query = getObjFromUrl(window.location.hash)
          this.getHistoryMenuData().then(() => {
            if (query.id) {
              const id = query.id
              const index = this.menueData.findIndex((item) => {
                return item.index == id
              })
              if (index > -1) {
                this.$store.dispatch('user/changeChatId', id)
                this.defaultActive = id
                return
              }
            }
            // this.$store.dispatch('user/changeChatId', result.data[0].conv_id)
            // this.defaultActive = this.menueData[0].index
          })
        } else {
          this.expandDefault = true
          this.defaultOpeneds = ['default']
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.el-menu::-webkit-scrollbar {
  width: 10px;
  height: 8px;
  background-color: transparent;
}
.el-menu::-webkit-scrollbar-thumb {
  background-color: #c1c1c1; /* 滑块背景颜色 */
  border: 2px solid transparent; /* 滑块边框，可以设置为透明或者具体的颜色 */
  background-clip: content-box; /* 使边框不覆盖滑块背景 */
  border-radius: 6px; /* 滑块圆角 */
}

.el-icon-s-custom {
  width: 18px !important;
}
.icon-manage::before {
  font-size: 20px;
}
.start-chat-content {
  padding: 20px 22px;
}
.start-chat-content .start-chat-btn {
  padding: 8px;
  background-color: #2f4eff;
  border-radius: 4px;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0em;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="less">
.month-area {
  margin-bottom: 10px;
  .month-title {
    font-size: 16px;
    color: #000;
    font-weight: bold;
    padding-left: 28px;
    margin-bottom: 6px;
  }
}
.logo {
  display: flex;
  position: relative;
  .relieve {
    position: absolute;
    color: #2e54f9;
    right: 20px;
    top: 20px;
    width: 30px;
    height: 30px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f4f5fa;
    cursor: pointer;
  }
  .nosticky .icon-relieve {
    color: gray;
    transform: rotate(90deg);
  }

  img {
    height: 35px;
    margin-top: 10px;
    margin-right: 20px;
    margin-left: 30px;
  }
  .logoTitle {
    font-size: 16px;
    font-family: inherit;
    font-weight: bold;
    color: #1d2043;
    margin-top: 14px;
    line-height: 20px;
    text-align: center;
  }
  .logoText {
    font-size: 14px;
    font-family: inherit;
    color: #1d2043;
    transform: scale(0.7);
    text-align: center;
    line-height: 10px;
  }
}
.aside-menu {
  position: relative;
  height: 100%;
  background-color: #fff;
  color: #1d2043;
}
.el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}
.el-submenu__title:hover,
.el-submenu__title:focus {
  background-color: transparent !important;
}
.el-submenu__title {
  background-color: transparent !important;
}
.sub-menu-title {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: #1d2043;
}
.sub-menu-title:hover {
  background-color: #f4f5fa;
}
.el-menu.bot-el-menu {
  background-color: #fff;
  color: #1d2043;
  border: none;
  height: calc(100% - 278px);
  overflow: auto;
  .el-menu-item {
    padding: 0px 10px 10px 20px !important;
    height: 44px;
    line-height: 44px;
    .menu-item {
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      color: #1d2043;
      .item-area {
        display: flex;
        align-items: center;
      }
    }
    .menu-item:hover {
      background-color: #f4f5fa;
    }
    .menu-item.answering {
      background-color: #f4f5fa;
      background-image: linear-gradient(
        to right,
        #4caf50,
        #4caf50 5px,
        transparent 5px,
        transparent
      );
    }
    .menu-item.waiting {
      // background-color: #f4f5fa;
      // background-image: linear-gradient(
      //   to right,
      //   #eec55b,
      //   #eec55b 5px,
      //   transparent 5px,
      //   transparent
      // );

      position: relative;
      z-index: 2;
    }
    .menu-item.waiting::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url('../assets/waiting-bg.gif');
      background-size: inherit;
      background-position: inherit;
      background-repeat: inherit;
      animation: blink-bg 1.5s infinite;
      z-index: -1;
    }

    @keyframes blink-bg {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .menu-item.timeout {
      background-color: #f4f5fa;
      background-image: linear-gradient(
        to right,
        #f44336,
        #f44336 5px,
        transparent 5px,
        transparent
      );
    }
    .icon-div {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      color: #1d2043;
    }

    // border-left: 8px solid rgba(0, 0, 0, 0);
    // margin-left: 8px;
    .menu-icon {
      margin-right: 5px;
      width: 16px;
      height: 16px;
      display: block;
      text-align: center;
      font-size: 18px;
      vertical-align: middle;
      color: inherit;
      background-size: contain;
      background-repeat: no-repeat;
      color: #1d2043;
    }
    .menu-icon.ready {
      background-image: url('~@/assets/icon/ready.png');
    }
    .menu-icon.answering {
      background-image: url('~@/assets/icon/answering.png');
      width: 18px;
      height: 18px;
      position: relative;
    }
    // .menu-icon.answering::after {
    //   content: '';
    //   position: absolute;
    //   top: -1px; /* 控制圆点距离顶部的距离 */
    //   right: -1px; /* 控制圆点距离右侧的距离 */
    //   width: 5px;
    //   height: 5px;
    //   background-color: #4caf50;
    //   border-radius: 50%;
    // }
    .menu-icon.waiting {
      background-image: url('~@/assets/icon/waiting.png');
      width: 18px;
      height: 18px;
      position: relative;
    }
    // .menu-icon.waiting::after {
    //   content: '';
    //   position: absolute;
    //   top: -1px; /* 控制圆点距离顶部的距离 */
    //   right: -1px; /* 控制圆点距离右侧的距离 */
    //   width: 5px;
    //   height: 5px;
    //   background-color: #eec55b;
    //   border-radius: 50%;
    // }
    .menu-icon.timeout {
      background-image: url('~@/assets/icon/timeout.png');
      width: 18px;
      height: 18px;
      position: relative;
    }
    // .menu-icon.timeout::after {
    //   content: '';
    //   position: absolute;
    //   top: -1px; /* 控制圆点距离顶部的距离 */
    //   right: -1px; /* 控制圆点距离右侧的距离 */
    //   width: 5px;
    //   height: 5px;
    //   background-color: #f44336;
    //   border-radius: 50%;
    // }
    .span-div {
      display: flex;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        width: 130px;
        font-size: 14px;
      }
    }
  }

  .el-menu-item:hover,
  .el-menu-item:focus {
    background-color: transparent;
    // // border-left: 8px solid #3A63F3;
    // box-shadow: 0px 2px 5px 0px rgba(159, 77, 0, 0.2);
    // color: #3a63f3;
  }
  .el-menu-item::before {
    content: '';
    margin-right: 16px;
    box-sizing: content-box;
  }

  .el-menu-item.is-active {
    // background-color: #3a63f33b;
    // border-left: 8px solid #3A63F3;
    // box-shadow: 0px 2px 5px 0px rgba(159, 77, 0, 0.2);
    .menu-item {
      color: #1d2043;
      background-color: #f4f5fa;
    }
    // padding: 10px 0;
  }

  .el-menu-item.is-active::before {
    content: '';
    margin-right: 0px;
    box-sizing: content-box;
    display: none;
  }
  .el-menu-item::before {
    content: '';
    margin-right: 0px;
    box-sizing: content-box;
    height: 0;
    display: none;
  }
}
.aside-menu {
  .el-submenu__title {
    padding-left: 20px !important;
    height: 40px !important;
  }

  .el-submenu .menu-item {
    padding-left: 20px !important;
  }
  .el-submenu {
    margin-bottom: 15px;
  }
}
.setup-btn-area {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 80px;
  cursor: pointer;
  color: #1d2043;
  padding: 10px 10px 10px 20px;
  .setup-btn {
    width: 230px;
    display: flex;
    align-items: center;
    height: 30px;
    // background-color: #f4f5fa;
    color: #5e6670;
    border-radius: 8px;
    margin-bottom: 10px;
    font-size: 14px;
  }

  .setup-btn:hover {
    color: #2e54f9;
  }
}
// .setup-btn-area.is-active {
//   background-color: #3a63f33b;
//   box-shadow: 0px 2px 5px 0px rgba(159, 77, 0, 0.2);
//   color: #3a63f3;
// }
// .setup-btn-area:hover {
//   background-color: #3a63f33b;
//   box-shadow: 0px 2px 5px 0px rgba(159, 77, 0, 0.2);
//   color: #3a63f3;
// }
</style>
<style lang="less">
.cost-reduce-dialog {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog {
    border-radius: 5px;
  }
  .el-dialog__body {
    padding: 0;
    border-radius: 5px;
  }
}
/* HTML: <div class="loader"></div> */
.aside-loader {
  width: 10px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 2px solid #514b82;
  animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  display: inline-block;
  margin-left: 10px;
}
@keyframes l20-1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }
  12.5% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }
  25% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }
  50% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  62.5% {
    clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  75% {
    clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  100% {
    clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}
@keyframes l20-2 {
  0% {
    transform: scaleY(1) rotate(0deg);
  }
  49.99% {
    transform: scaleY(1) rotate(135deg);
  }
  50% {
    transform: scaleY(-1) rotate(0deg);
  }
  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}
</style>
